<template>
	<div class="p-2">
		<vs-avatar class="mx-auto mb-6 block" size="80px" :src="avatar" />
		<div class="text-center">
			<h4>{{ resourceData.username }}</h4>
			<p class="text-grey">{{ fullname }}</p>
		</div>
		<div class="flex justify-between mt-4 mb-4">
			<span class="flex items-center mr-4">
				<feather-icon
					:icon="batteryLevelIcon.icon"
					:svgClasses="'h-7 w-7 stroke-current ' + batteryLevelIcon.color"
				/>
				<span class="ml-2">{{ tracking.battery }}%</span>
			</span>
			<span class="flex items-center mr-4">
				<feather-icon
					icon="WifiIcon"
					:svgClasses="'h-7 w-7 stroke-current ' + tracking.getTransmissionColor()"
				/>
				<span class="ml-2">{{ tracking.getTransmissionText() }}</span>
			</span>
			<span class="flex items-center mr-4">
				<vs-icon
					class="mt-1"
					:icon="gpsIcon"
					size="small"
					:color="gpsIcon === 'gps_fixed' ? 'primary' : 'secondary'"
				></vs-icon>
				<span class="ml-2">{{ tracking.gps }}</span>
			</span>
		</div>
	</div>
</template>
<script>
import BridgeInstance from "./bridgeInstance";
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";

export default {
	props: ["tracking", "resourceData"],
	data() {
		return {
			card_4: {},
			avatar: "",
		};
	},
	computed: {
		fullname() {
			return this.resourceData.name + " " + this.resourceData.lastname;
		},
		batteryLevelIcon() {
			return this.tracking.getBatteryIcon();
		},
		gpsIcon() {
			return this.tracking.gps === "on" ? "gps_fixed" : "gps_off";
		},
	},
	methods: {
		getResourcePhoto() {
			const url = this.resourceData.img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					if (res) {
						this.avatar = res;
					}
				})
				.catch((error) => {});
		},
	},
	mounted() {
		this.getResourcePhoto();
	},
};
</script>
